import Hook from "../utils/hook"

export default Hook(`MenuedContent`, {
  values: { index: Number },
  targets: [`button`, `content`],
  actions: [
    {
      name: `keyup`,
      type: `keyup`,
    },
  ],

  indexValueChanged(indexValue) {
    this.contentTargets[indexValue]?.scrollIntoView({
      block: `nearest`,
    })
  },

  keyupAction(e) {
    if (
      [`ArrowLeft`, `ArrowRight`, `ArrowUp`, `ArrowDown`].includes(e.key) &&
      this.buttonTargets.indexOf(document.activeElement) > -1
    ) {
      let index = this.indexValue
      if ([`ArrowLeft`, `ArrowUp`].includes(e.key)) {
        index--
        index = index < 0 ? this.buttonTargets.length - 1 : index
      } else {
        index++
        index = index >= this.buttonTargets.length ? 0 : index
      }

      this.pushEventToSelf(`set_index`, { index })
      this.buttonTargets[index]?.focus()
    }
  },
})
